import { pageBasedUrlGenerator } from './tvShowDetailsHandler';
import { TvShowRelatedContent } from '../../services/GraphQL/Queries/types';
import { TV_SHOW_PAGE_CONSTANTS } from '../constants/TvShowDetailsPageConstants';
import { titleGenerator } from '../routeHandler';

export const getCurrentSeasonIndexFromUrl = (
  seasonIndexFromRouter: string
): number => {
  if (seasonIndexFromRouter === null) return 1;
  const seasonNumber =
    typeof seasonIndexFromRouter == 'string' &&
    seasonIndexFromRouter?.split('-');
  const urlSeasonNumber = seasonNumber ? parseInt(seasonNumber[1], 10) : null;
  return urlSeasonNumber || 1;
};

export const getMaximumNumberOfSeasons = (tvshowData: TvShowRelatedContent) => {
  return tvshowData.seasons?.length || 1;
};

export const isCorrectUrl = (seasonIndexFromRouter: string): boolean => {
  const seasonNumber =
    seasonIndexFromRouter?.length && seasonIndexFromRouter?.split('-')[1];
  return !isNaN(parseInt(seasonNumber as string, 10));
};

export const generateInterval = (tvShowDetails: TvShowRelatedContent) => {
  const { seasons } = tvShowDetails;
  if (seasons && seasons.length > 0) {
    return seasons.map((season, index) => {
      const seasonNumber =
        season && season.index !== undefined ? season.index : index + 1;
      return `Season ${seasonNumber}`;
    });
  }

  return [];
};

export const generateMultipleSeasonRedirectionUrl = (
  seasonIndexFromRouter: string,
  data: TvShowRelatedContent
) => {
  const actualTitle = titleGenerator(data.title as string);
  const newPathName =
    data?.assetSubType &&
    data?.genres &&
    `${pageBasedUrlGenerator(
      data?.webSlug || data?.slug || data?.webUrl || '',
      data?.assetSubType,
      data?.genres,
      data?.contentPartnerDetails,
      actualTitle
    )}`;
  let redirectUrl = '';
  if (
    data &&
    Object.keys(data)?.length &&
    data?.seasons &&
    data?.seasons?.length
  ) {
    const seasonFromUrl = getCurrentSeasonIndexFromUrl(seasonIndexFromRouter);
    const maxNumberOfSeasons = getMaximumNumberOfSeasons(data) || 1;

    if (
      (maxNumberOfSeasons < seasonFromUrl ||
        !isCorrectUrl(seasonIndexFromRouter)) &&
      seasonFromUrl !== 1
    ) {
      redirectUrl = `${newPathName}/${TV_SHOW_PAGE_CONSTANTS.SEASON}-${maxNumberOfSeasons}/${TV_SHOW_PAGE_CONSTANTS.EPISODES}`;
    } else if (seasonFromUrl === 1) {
      redirectUrl = `${newPathName}/${TV_SHOW_PAGE_CONSTANTS.EPISODES}`;
    } else {
      redirectUrl = `${newPathName}/${TV_SHOW_PAGE_CONSTANTS.SEASON}-${seasonFromUrl}/${TV_SHOW_PAGE_CONSTANTS.EPISODES}`;
    }
  }
  return redirectUrl;
};

export const getActiveSeasonIndex = (
  index: number,
  detailsData: TvShowRelatedContent
) => {
  return (
    detailsData?.seasons?.findIndex((season) => season?.index === index) || 0
  );
};
